"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleDriveFindFile = exports.googleDriveFindFileResultSchema = exports.googleDriveFindFileArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleDriveFindFileArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('find-file', zod_1.z.object({
    nameSearchTerm: zod_1.z
        .string()
        .describe('Search for a file by name (equivalent to the query `name contains [value]`)'),
}));
var googleDriveFileSchema = zod_1.z.object({
    kind: zod_1.z.string().describe('Identifies what kind of resource this is'),
    mimeType: zod_1.z.string().describe('The MIME type of the file'),
    name: zod_1.z.string().describe('The name of the file'),
    id: zod_1.z.string().describe('The id of this file'),
});
exports.googleDriveFindFileResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.array(googleDriveFileSchema));
exports.googleDriveFindFile = (0, common_1.createToolMetadata)({
    id: 'googleDriveFindFile',
    displayName: 'Google Drive Find File',
    displayDescription: 'Find a file by name in Google Drive',
    category: 'integration',
    color: common_1.BRAND_COLORS.GOOGLE_DRIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_DRIVE),
    icon: 'google_drive',
    argsSchema: exports.googleDriveFindFileArgsSchema,
}, exports.googleDriveFindFileResultSchema);
